import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { useDevice } from '../../contexts/DeviceContext.js';
import { cn } from '../../lib/utils.js';

const Input = React.forwardRef(
  ({ className, type, autoComplete = "off", ...props }, ref) => {
    const { isDesktop } = useDevice();
    return /* @__PURE__ */ jsx(
      "input",
      {
        type,
        className: cn(
          isDesktop && "placeholder:body-lg body-lg",
          "flex h-6 w-full bg-base-white body-lg text-basic-02 transition-colors file:border-0 file:bg-base-white file:font-weight-medium placeholder:text-basic-04 focus-visible:outline-none disabled:cursor-not-allowed disabled:text-state-disabled-04",
          className
        ),
        ref,
        ...props,
        autoComplete
      }
    );
  }
);
Input.displayName = "Input";

export { Input };
